/**
 * Return a new array which is shuffled, while leaving the original one alone.
 * @param items - Array of items to shuffle.
 */
export function shuffleArray<T>(items: T[]): T[] {
    return items
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
}
